import { AbstractFormFragment } from '@components/form/AbstractFormFragment';

export class RadioGroupFormFragment extends AbstractFormFragment {
  static getCssClassName(): string {
    return 'comp-form-radios';
  }

  initializeNode(): this {
    this.blurOnMouseRealMouseClick();
    return this;
  }

  // NOTE: original used global $("input[type=radio]:checked") — scoping bug. Fixed to scope to this.node.
  hasValue(): boolean {
    return !!this.node.querySelector('input[type=radio]:checked');
  }

  getLabel(): string {
    return this.node.querySelector('div.label')?.textContent?.trim() ?? '';
  }

  attachChangeListener(callback: () => void): this {
    this.node.querySelectorAll<HTMLInputElement>('input[type=radio]').forEach((input) => {
      input.addEventListener('change', () => callback());
    });
    return this;
  }
}

export default RadioGroupFormFragment;
